var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _c("div", { staticClass: "box-body" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("dropdown", {
              staticClass: "form-control",
              attrs: {
                "value-field": "value",
                "text-field": "text",
                placeholder: _vm.resource(
                  "SettingsDivisionMiscellaneous_Index_CategoryDropdown_Placeholder"
                ),
                options: _vm.sortedCategoryDropdownOptions,
                value: _vm.selectedCategory.id
              },
              on: { input: _vm.categorySelected }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-8 form-group" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("h3", [
                _vm._v(
                  _vm._s(
                    _vm.resource(
                      "SettingsDivisionMiscellaneous_Index_CategoryHeader"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 text-right" }, [
              _vm.canSaveCategory
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: { click: _vm.saveCategory }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.resource(
                            "SettingsDivisionMiscellaneous_Index_SaveButton_Text"
                          )
                        ) + "\n                        "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canDeleteCategory
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      on: { click: _vm.deleteCategory }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.resource(
                            "SettingsDivisionMiscellaneous_Index_DeleteButton_Text"
                          )
                        ) + "\n                        "
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-8" },
          [
            _c("miscellaneous-category", {
              attrs: { category: _vm.selectedCategory }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-8 text-right" }, [
          _vm.canSaveCategory
            ? _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: { click: _vm.saveCategory }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.resource(
                        "SettingsDivisionMiscellaneous_Index_SaveButton_Text"
                      )
                    )
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canDeleteCategory
            ? _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  on: { click: _vm.deleteCategory }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.resource(
                        "SettingsDivisionMiscellaneous_Index_DeleteButton_Text"
                      )
                    )
                  )
                ]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [_c("hr")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }